module.exports = __webpack_public_path__ + "static/media/fa-v4compatibility.7c428138.woff2";